import React from 'react';
import TableHead from "./TableHead";
import 'swiper/css/swiper.min.css';
import Banner from "./Banner";

class BlockTop extends React.Component {

    render() {
        return <React.Fragment>
            <div className="modules_top">
                <div>
                    <div id="hottoday">
                        <div>
                            <TableHead/>
                        </div>
                    </div>
                    <div className="clear"/>
                </div>
                <div>
                    <Banner/>
                    <div className="clear"/>
                </div>
            </div>
        </React.Fragment>;
    }
}

export default BlockTop;
